function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { getCategoryByProvider, getPeriodPerformance, getProductTypesByCategory, getPeriod, getPeriodPerformanceLabel, getYearlyPerformance, getPeriodStat, getFundClassFee, getStatLabel, getStatTooltip, getFundMainClass, getBreakdownDefinition, getBreakdown, getProductTypeLabel } from '@finect/front-resources/Products';
import { isArray } from '@finect/front-utils/isArray';
import { QuoteLabel, PercentLabel, AssetsLabel, NumberLabel } from '../../Labels';
import { InfoLabel } from '../../InfoLabel';
import { ManagementCompany } from '../../ManagementCompanies';
import { Category } from '../../Categories';
import { SrriBar } from '../../SrriBar';
import { Stars } from '../../../Stars';
import { DateLabel } from '../../../DateLabel';
import { Link } from '../ProductRow/Link';
import { getProductTransactionableOrganizations } from '../../utils';
import { FundClassFee } from '../ProductRow/FundClassFee';
import { RiskProfile } from '../ProductRow/RiskProfile';
import { RiskProfileUserHint } from '../ProductRow/RiskProfileUserHint';
import { FundClasses } from '../ProductRow/FundClasses';
import { ProductName } from '../ProductRow/ProductName';
import { Price } from '../ProductRow/Price';
import { ESGRating } from '../ProductRow/ESGRating';
import { TextESGRating } from '../ProductRow/TextESGRating';
import { breakdownDefinitions } from './breakdownDefinitions';
import { ProductMetadata } from './../ProductRow/ProductMetadata';
import { FundMinInvestment } from './../ProductRow/FundMinInvestment';
import { BuyButton } from './../ProductRow/BuyButton';
import { LikeAction } from './../ProductRow/LikeAction';
import { ButtonLink } from './../ProductRow/ButtonLink';
import { Feature } from './../ProductRow/Feature';
import { PerformanceBars } from './../../Charts/PerformanceBars';
import { Sparkline } from './../../Charts/Sparkline';
import { ProductDistributors } from './../ProductRow/ProductDistributors';
import { Questions } from './../ProductRow/Questions';
import { Reviews } from './../ProductRow/Reviews';
import { LastQuoteHeadline } from './../ProductRow/LastQuote';
import { compare, meta } from './utils';
import { features } from './features';
import { metadatas } from './metadatas';
import { fundFees } from './fundFees';
var iicTypes = getProductTypesByCategory('iic').map(function (_ref) {
  var id = _ref.id;
  return id;
});
var tooltips = {
  minInvestment: {
    title: 'Inversión mínima',
    text: 'Cantidad mínima que se puede invertir en el producto.'
  },
  srri: {
    title: 'Volatilidad',
    text: 'Mide la frecuencia con la que varía el precio de un activo.',
    link: 'https://www.finect.com/usuario/vanesamatesanz/articulos/que-srri-fondo-que-importante'
  }
};
export var productFields = [{
  id: 'name',
  map: function map(product, params, _ref2) {
    var portfolio = _ref2.portfolio;
    return {
      product: product,
      portfolio: portfolio
    };
  },
  props: function props(_ref3) {
    var item = _ref3.value,
      productType = _ref3.productType,
      position = _ref3.position,
      _ref3$useProductClass = _ref3.useProductClassName,
      useProductClassName = _ref3$useProductClass === void 0 ? false : _ref3$useProductClass,
      _ref3$context = _ref3.context,
      context = _ref3$context === void 0 ? [] : _ref3$context,
      params = _ref3.params;
    return _objectSpread({
      item: item,
      productType: productType,
      position: position,
      useProductClassName: useProductClassName,
      context: context
    }, params);
  },
  component: ProductName,
  label: 'Nombre'
}, {
  id: 'distributors',
  map: function map(_ref4) {
    var entity = _ref4.entity;
    return entity;
  },
  mapValue: function mapValue(_ref5) {
    var entity = _ref5.entity;
    return getProductTransactionableOrganizations(entity);
  },
  parserValue: function parserValue(value) {
    return value.map(function (item) {
      return {
        id: item.id,
        label: item.displayName,
        image: "/image/".concat(item.icon),
        model: _objectSpread({}, item)
      };
    });
  },
  props: function props(_ref6) {
    var entity = _ref6.value,
      params = _ref6.params;
    return {
      entity: entity,
      qty: params.qty || 2
    };
  },
  component: ProductDistributors,
  label: 'Distribuido por'
}, {
  id: 'portfolioAmount',
  map: function map(product, params, _ref7) {
    var portfolio = _ref7.portfolio;
    return portfolio.amount;
  },
  mapCompare: function mapCompare(product, params, _ref8) {
    var portfolio = _ref8.portfolio;
    return portfolio.amount;
  },
  props: function props(_ref9) {
    var value = _ref9.value;
    return {
      value: value,
      decimals: 2
    };
  },
  compare: compare,
  component: AssetsLabel,
  label: 'Valoración',
  unit: 'percent',
  tooltip: {
    title: 'Valoración',
    text: 'Importe de tu inversión según el precio del último valor liquidativo.'
  }
}, {
  id: 'portfolioProfitAmount',
  map: function map(product, params, _ref10) {
    var portfolio = _ref10.portfolio;
    return portfolio && portfolio.profit ? portfolio.profit.amount : null;
  },
  mapCompare: function mapCompare(product, params, _ref11) {
    var portfolio = _ref11.portfolio;
    return portfolio.profit.amount;
  },
  props: function props(_ref12) {
    var value = _ref12.value;
    return {
      value: value,
      decimals: 2
    };
  },
  compare: compare,
  component: AssetsLabel,
  label: 'Beneficio (€)'
}, {
  id: 'portfolioProfitPercent',
  map: function map(product, params, _ref13) {
    var portfolio = _ref13.portfolio;
    return portfolio && portfolio.profit ? portfolio.profit.percent : null;
  },
  mapCompare: function mapCompare(product, params, _ref14) {
    var portfolio = _ref14.portfolio;
    return portfolio.profit.percent;
  },
  props: function props(_ref15) {
    var value = _ref15.value;
    return {
      value: value,
      decimals: 2
    };
  },
  compare: compare,
  component: PercentLabel,
  label: 'Beneficio (%)'
}, {
  id: 'buttonLink',
  map: function map(product, params, _ref16) {
    var portfolio = _ref16.portfolio;
    return {
      product: product,
      portfolio: portfolio
    };
  },
  props: function props(_ref17) {
    var item = _ref17.value,
      productType = _ref17.productType,
      params = _ref17.params,
      position = _ref17.position,
      context = _ref17.context;
    return _objectSpread({
      context: context,
      position: position,
      item: item,
      productType: productType
    }, params);
  },
  component: ButtonLink,
  label: ''
}, {
  id: 'performance',
  map: function map(_ref18, _ref19) {
    var entity = _ref18.entity;
    var period = _ref19.period,
      type = _ref19.type;
    var periodType = type || (['M120', 'M24', 'M255', 'M36', 'M48', 'M60', 'M84'].includes(period) ? 'annualized' : 'accumulated');
    return entity.stats ? getPeriodPerformance(entity.stats, period, periodType) : null;
  },
  props: function props(_ref20) {
    var value = _ref20.value,
      params = _ref20.params;
    return {
      value: value ? value.value : null,
      decimals: 2,
      withSparkline: params.withSparkline,
      withPositiveSign: params.withPositiveSign
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref21) {
    var period = _ref21.period,
      _label = _ref21.label,
      format = _ref21.format,
      type = _ref21.type;
    if (_label) {
      return _label;
    }
    if (['stat'].includes(format)) {
      var periodType = type || (['M120', 'M24', 'M255', 'M36', 'M48', 'M60', 'M84'].includes(period) ? 'annualized' : 'accumulated');
      return "".concat(getStatLabel('performance', period, format), " ").concat(periodType === 'annualized' ? ' anualizada' : '');
    }
    if (['summary', 'short', 'long'].includes(format)) {
      return getPeriodPerformanceLabel(period, format);
    }
    var periodData = getPeriod(period);
    if (periodData && periodData.tableLabel) {
      return ['Rentabilidad', periodData.tableLabel];
    }
    return period;
  },
  defaultParams: {
    period: 'M36',
    withSparkline: true,
    withPositiveSign: false
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref22) {
    var period = _ref22.period;
    return {
      title: getPeriodPerformanceLabel(period, 'long'),
      text: 'Beneficio (o pérdida) obtenido en una inversión en un período de tiempo determinado. Se suele expresar en términos porcentuales.'
    };
  },
  complement: {
    id: 'feature',
    feature: 'value-for-money'
  }
}, {
  id: 'performance-new',
  map: function map(_ref23, _ref24) {
    var entity = _ref23.entity;
    var period = _ref24.period,
      type = _ref24.type;
    var periodType = type || (['M120', 'M24', 'M255', 'M36', 'M48', 'M60', 'M84'].includes(period) ? 'annualized' : 'accumulated');
    return entity.stats ? getPeriodPerformance(entity.stats, period, periodType) : ['M0', 'M60'].includes(period) ? {
      value: '-'
    } : null;
  },
  props: function props(_ref25) {
    var value = _ref25.value,
      params = _ref25.params;
    return {
      value: value ? value.value : null,
      unit: 'percent',
      decimals: 2,
      label: params.label,
      border: params.border,
      fullWidth: true,
      withSpacer: true,
      withTextColor: false,
      withSparkline: true,
      withPositiveSign: true
    };
  },
  label: function label(_ref26) {
    var _label2 = _ref26.label;
    return _label2;
  },
  component: InfoLabel
}, {
  id: 'sharpeRatio',
  map: function map(_ref27, _ref28) {
    var entity = _ref27.entity;
    var period = _ref28.period;
    return getPeriodStat(entity.stats, period, 'sharpeRatio');
  },
  props: function props(_ref29) {
    var value = _ref29.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref30) {
    var period = _ref30.period,
      _ref30$format = _ref30.format,
      format = _ref30$format === void 0 ? 'table' : _ref30$format;
    return getStatLabel('sharpeRatio', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref31) {
    var period = _ref31.period;
    return getStatTooltip('sharpeRatio', period);
  }
}, {
  id: 'trackingError',
  map: function map(_ref32, _ref33) {
    var entity = _ref32.entity;
    var period = _ref33.period;
    return getPeriodStat(entity.stats, period, 'trackingError');
  },
  props: function props(_ref34) {
    var value = _ref34.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref35) {
    var period = _ref35.period,
      _ref35$format = _ref35.format,
      format = _ref35$format === void 0 ? 'table' : _ref35$format;
    return getStatLabel('trackingError', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref36) {
    var period = _ref36.period;
    return getStatTooltip('trackingError', period);
  }
}, {
  id: 'r2',
  map: function map(_ref37, _ref38) {
    var entity = _ref37.entity;
    var period = _ref38.period;
    return getPeriodStat(entity.stats, period, 'r2');
  },
  props: function props(_ref39) {
    var value = _ref39.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref40) {
    var period = _ref40.period,
      _ref40$format = _ref40.format,
      format = _ref40$format === void 0 ? 'table' : _ref40$format;
    return getStatLabel('r2', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref41) {
    var period = _ref41.period;
    return getStatTooltip('r2', period);
  }
}, {
  id: 'correlation',
  map: function map(_ref42, _ref43) {
    var entity = _ref42.entity;
    var period = _ref43.period;
    return getPeriodStat(entity.stats, period, 'correlation');
  },
  props: function props(_ref44) {
    var value = _ref44.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref45) {
    var period = _ref45.period,
      _ref45$format = _ref45.format,
      format = _ref45$format === void 0 ? 'table' : _ref45$format;
    return getStatLabel('correlation', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref46) {
    var period = _ref46.period;
    return getStatTooltip('correlation', period);
  }
}, {
  id: 'informationRatio',
  map: function map(_ref47, _ref48) {
    var entity = _ref47.entity;
    var period = _ref48.period;
    return getPeriodStat(entity.stats, period, 'informationRatio');
  },
  props: function props(_ref49) {
    var value = _ref49.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref50) {
    var period = _ref50.period,
      _ref50$format = _ref50.format,
      format = _ref50$format === void 0 ? 'table' : _ref50$format;
    return getStatLabel('informationRatio', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref51) {
    var period = _ref51.period;
    return getStatTooltip('informationRatio', period);
  }
}, {
  id: 'breakdown',
  map: function map(_ref52, _ref53) {
    var entity = _ref52.entity;
    var breakdown = _ref53.breakdown;
    return getBreakdown(entity.breakdown, breakdown);
  },
  props: function props(_ref54) {
    var value = _ref54.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref55) {
    var breakdown = _ref55.breakdown;
    var definition = getBreakdownDefinition(breakdownDefinitions, breakdown);
    return definition ? definition.label : '';
  }
}, {
  id: 'alpha',
  map: function map(_ref56, _ref57) {
    var entity = _ref56.entity;
    var period = _ref57.period;
    return getPeriodStat(entity.stats, period, 'alpha');
  },
  props: function props(_ref58) {
    var value = _ref58.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref59) {
    var period = _ref59.period,
      _ref59$format = _ref59.format,
      format = _ref59$format === void 0 ? 'table' : _ref59$format;
    return getStatLabel('alpha', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref60) {
    var period = _ref60.period;
    return getStatTooltip('alpha', period);
  }
}, {
  id: 'beta',
  map: function map(_ref61, _ref62) {
    var entity = _ref61.entity;
    var period = _ref62.period;
    return getPeriodStat(entity.stats, period, 'beta');
  },
  props: function props(_ref63) {
    var value = _ref63.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: NumberLabel,
  type: 'number',
  label: function label(_ref64) {
    var period = _ref64.period,
      _ref64$format = _ref64.format,
      format = _ref64$format === void 0 ? 'table' : _ref64$format;
    return getStatLabel('beta', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref65) {
    var period = _ref65.period;
    return getStatTooltip('beta', period);
  }
}, {
  id: 'standardDeviation',
  map: function map(_ref66, _ref67) {
    var entity = _ref66.entity;
    var period = _ref67.period;
    return getPeriodStat(entity.stats, period, 'standardDeviation');
  },
  props: function props(_ref68) {
    var value = _ref68.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref69) {
    var period = _ref69.period,
      _ref69$format = _ref69.format,
      format = _ref69$format === void 0 ? 'table' : _ref69$format;
    return getStatLabel('standardDeviation', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref70) {
    var period = _ref70.period;
    return getStatTooltip('standardDeviation', period);
  }
}, {
  id: 'maxDrawdown',
  map: function map(_ref71, _ref72) {
    var entity = _ref71.entity;
    var period = _ref72.period;
    return getPeriodStat(entity.stats, period, 'maxDrawdown');
  },
  props: function props(_ref73) {
    var value = _ref73.value;
    return {
      value: value ? value.value : null,
      decimals: 2
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref74) {
    var period = _ref74.period,
      _ref74$format = _ref74.format,
      format = _ref74$format === void 0 ? 'table' : _ref74$format;
    return getStatLabel('maxDrawdown', period, format);
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref75) {
    var period = _ref75.period;
    return getStatTooltip('maxDrawdown', period);
  }
}, {
  id: 'fee',
  productType: iicTypes,
  map: function map(_ref76, _ref77) {
    var entity = _ref76.entity;
    var fee = _ref77.fee;
    return getFundClassFee(entity, fee);
  },
  props: function props(_ref78) {
    var value = _ref78.value;
    return {
      value: value ? value.value : null,
      decimals: 3
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref79) {
    var fee = _ref79.fee;
    var def = fundFees.find(function (_ref80) {
      var id = _ref80.id;
      return id.toLowerCase() === fee.toLowerCase();
    });
    return def ? def.label : fee;
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref81) {
    var fee = _ref81.fee;
    var def = fundFees.find(function (_ref82) {
      var id = _ref82.id;
      return id.toLowerCase() === fee.toLowerCase();
    });
    return def ? def.tooltip : null;
  }
}, {
  id: 'fee-new',
  productType: iicTypes,
  map: function map(_ref83, _ref84) {
    var entity = _ref83.entity;
    var fee = _ref84.fee;
    return getFundClassFee(entity, fee);
  },
  props: function props(_ref85) {
    var value = _ref85.value,
      params = _ref85.params;
    return {
      value: value ? value.value : null,
      decimals: 3,
      unit: 'percent',
      trend: 'none',
      label: params.label,
      border: params.border,
      withTextColor: false,
      fullWidth: true,
      withSpacer: true
    };
  },
  label: function label(_ref86) {
    var _label3 = _ref86.label;
    return _label3;
  },
  component: InfoLabel
}, {
  id: 'benchmarks',
  map: function map(_ref87) {
    var entity = _ref87.entity;
    return entity.benchmarks;
  },
  props: function props(_ref88) {
    var value = _ref88.value;
    return {
      value: value
    };
  },
  component: function component(_ref89) {
    var value = _ref89.value;
    if (value.length > 1) {
      return React.createElement("span", null, value.map(function (benchmark, key) {
        return React.createElement("span", {
          key: key
        }, React.createElement(PercentLabel, {
          value: benchmark.allocation,
          decimals: 0
        }), " ", React.createElement("span", null, benchmark.name), key + 1 !== value.length ? React.createElement("span", null, ", ") : null);
      }));
    }
    if (!value.length) {
      return '-';
    }
    return value.map(function (benchmark, key) {
      return React.createElement("span", {
        key: key
      }, benchmark.name);
    });
  },
  label: function label() {
    return 'Benchmark';
  }
}, {
  id: 'indexed',
  map: function map(_ref90) {
    var entity = _ref90.entity;
    return entity.attributes;
  },
  props: function props(_ref91) {
    var value = _ref91.value;
    return {
      value: value.indexed
    };
  },
  component: function component(_ref92) {
    var value = _ref92.value;
    return value ? 'Sí' : 'No';
  },
  label: function label(_, productType) {
    return "".concat(getProductTypeLabel(productType, 'shortSingular', 'none'), " indexado");
  }
}, {
  id: 'yearlyPerformance',
  map: function map(_ref93, _ref94) {
    var entity = _ref93.entity;
    var year = _ref94.year;
    var currentYear = new Date().getFullYear();
    var yearly = getYearlyPerformance(entity.stats, year);
    var periodly = getPeriodPerformance(entity.stats, 'M0', 'accumulated');
    if (!yearly && year === currentYear) {
      if (!periodly) return null;
      if (new Date(periodly.date).getFullYear() === currentYear) return periodly;
      return null;
    }
    return yearly;
  },
  props: function props(_ref95) {
    var value = _ref95.value,
      params = _ref95.params;
    return {
      value: value ? value.value : null,
      decimals: 2,
      withSparkline: params.withSparkline,
      withPositiveSign: params.withPositiveSign
    };
  },
  component: PercentLabel,
  type: 'number',
  label: function label(_ref96) {
    var year = _ref96.year,
      _label4 = _ref96.label,
      _ref96$format = _ref96.format,
      format = _ref96$format === void 0 ? 'table' : _ref96$format;
    if (['chart'].includes(format)) {
      return year;
    }
    if (['table'].includes(format)) {
      return ['Rentabilidad', year];
    }
    return _label4 ? _label4 : "Rent. a\xF1o ".concat(year);
  },
  defaultParams: {
    withSparkline: true,
    withPositiveSign: false
  },
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: function tooltip(_ref97) {
    var year = _ref97.year;
    return {
      title: "Rentabilidad a\xF1o ".concat(year),
      text: 'Beneficio (o pérdida) obtenido en una inversión en un período de tiempo determinado. Se suele expresar en términos porcentuales.'
    };
  }
}, {
  id: 'performanceBars',
  productType: iicTypes,
  map: function map(_ref98) {
    var entity = _ref98.entity;
    return entity.stats ? entity.stats.performance.months : [];
  },
  props: function props(_ref99) {
    var value = _ref99.value;
    return {
      bars: value.map(function (item) {
        return item.value >= 0;
      })
    };
  },
  component: PerformanceBars,
  label: ''
}, {
  id: 'sparklineBars',
  productType: iicTypes,
  map: function map(_ref100) {
    var entity = _ref100.entity;
    return entity.chartData ? entity.chartData.data : [];
  },
  props: function props(_ref101) {
    var value = _ref101.value;
    return {
      data: value.map(function (item) {
        return item;
      })
    };
  },
  component: Sparkline,
  label: 'Rentabilidad mensual'
}, {
  id: 'totalNetAsset',
  map: function map(_ref102) {
    var entity = _ref102.entity;
    return entity.totalNetAsset;
  },
  props: function props(_ref103) {
    var value = _ref103.value;
    return {
      value: value,
      decimals: 1,
      scale: 'million'
    };
  },
  productType: iicTypes,
  component: AssetsLabel,
  label: 'Patrimonio del fondo',
  mapCompare: function mapCompare(product, params, model, value) {
    return value;
  },
  compare: compare
}, {
  id: 'classTotalNetAsset',
  map: function map(_ref104) {
    var entity = _ref104.entity;
    var _ref105 = getFundMainClass(entity) || {},
      _ref105$classTotalNet = _ref105.classTotalNetAsset,
      classTotalNetAsset = _ref105$classTotalNet === void 0 ? null : _ref105$classTotalNet;
    return classTotalNetAsset;
  },
  props: function props(_ref106) {
    var value = _ref106.value;
    return {
      value: value,
      decimals: 1,
      scale: 'million'
    };
  },
  productType: iicTypes,
  component: AssetsLabel,
  label: 'Patrimonio de la clase',
  mapCompare: function mapCompare(product, params, model, value) {
    return value;
  },
  compare: compare
}, {
  id: 'finectRating',
  map: function map(_ref107) {
    var entity = _ref107.entity;
    return entity.ratings.find(function (item) {
      return item.provider === 'finect';
    });
  },
  props: function props(_ref108) {
    var value = _ref108.value;
    return {
      value: value.value
    };
  },
  productType: iicTypes,
  component: Stars,
  label: 'Valoración',
  mapCompare: function mapCompare(product, params, model, value) {
    return value ? value.value : 0;
  },
  compare: compare,
  tooltip: {
    title: 'Valoración en Finect',
    text: 'Media de las valoraciones que han puesto los expertos financieros y usuarios en Finect.'
  }
}, {
  id: 'finectRating',
  map: function map(_ref109) {
    var entity = _ref109.entity;
    return entity.score;
  },
  props: function props(_ref110) {
    var value = _ref110.value;
    return {
      value: value
    };
  },
  component: Stars,
  label: 'Valoración',
  tooltip: {
    title: 'Valoración en Finect',
    text: 'Media de las valoraciones que han puesto los expertos financieros y usuarios en Finect.'
  }
}, {
  id: 'feature',
  map: function map(_ref111, _ref112) {
    var entity = _ref111.entity;
    var feature = _ref112.feature;
    var value = entity.features.find(function (_ref113) {
      var alias = _ref113.alias;
      return feature === alias;
    });
    return value ? value : {
      alias: null,
      name: null,
      score: null
    };
  },
  mapCompare: function mapCompare(_ref114, _ref115) {
    var entity = _ref114.entity;
    var feature = _ref115.feature;
    var value = entity.features.find(function (_ref116) {
      var alias = _ref116.alias;
      return feature === alias;
    });
    return value ? value.score : 0;
  },
  props: function props(_ref117) {
    var value = _ref117.value;
    return {
      value: value
    };
  },
  compare: compare,
  component: Feature,
  label: function label(params) {
    return features.find(function (item) {
      return item.id === params.feature;
    }).label;
  },
  tooltip: function tooltip(params) {
    var def = features.find(function (item) {
      return item.id === params.feature;
    });
    return def ? def.tooltip : null;
  }
}, {
  id: 'minInvestment',
  map: function map(_ref118) {
    var entity = _ref118.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'minimum_investment_amount';
    });
  },
  mapCompare: function mapCompare(_ref119) {
    var entity = _ref119.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'minimum_investment_amount';
    }) ? Number(entity.metadata.find(function (item) {
      return item.meta === 'minimum_investment_amount';
    }).data) : 0;
  },
  productType: ['deposit'],
  compare: compare,
  component: QuoteLabel,
  props: function props(_ref120) {
    var value = _ref120.value;
    return {
      value: value ? Number(value.data) : null,
      decimals: 0
    };
  },
  label: 'Inversión mínima',
  type: 'number',
  tooltip: tooltips.minInvestment
}, {
  id: 'apr',
  map: function map(product) {
    return meta(product, 'effective_interest_rate');
  },
  mapCompare: function mapCompare(_ref121) {
    var entity = _ref121.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'effective_interest_rate';
    }) ? Number(entity.metadata.find(function (item) {
      return item.meta === 'effective_interest_rate';
    }).data) : 0;
  },
  productType: ['deposit'],
  compare: compare,
  props: function props(_ref122) {
    var value = _ref122.value;
    var valueSplit = value ? value.data.split('-') : [];
    var result = {
      value: value ? Number(valueSplit[0]) : null,
      decimals: 2
    };
    if (valueSplit.length > 1) {
      return _objectSpread(_objectSpread({}, result), {}, {
        value2: value ? Number(valueSplit[1]) : null,
        isRange: true
      });
    }
    return result;
  },
  component: PercentLabel,
  label: 'TAE',
  type: 'number',
  tooltip: {
    title: 'Tasa anual equivalente',
    text: "La TAE sirve para medir la rentabilidad de una inversi\xF3n o,\n      en el caso de un pr\xE9stamo, el tipo de inter\xE9s que vas a pagar.",
    link: 'https://www.finect.com/usuario/Josetrecet/articulos/que-tae'
  }
}, {
  id: 'interest_rate',
  map: function map(_ref123) {
    var entity = _ref123.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'nominal_interest_rate';
    });
  },
  mapCompare: function mapCompare(_ref124) {
    var entity = _ref124.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'nominal_interest_rate';
    }) ? Number(entity.metadata.find(function (item) {
      return item.meta === 'nominal_interest_rate';
    }).data) : 0;
  },
  productType: ['deposit'],
  compare: compare,
  props: function props(_ref125) {
    var value = _ref125.value;
    var valueSplit = value ? value.data.split('-') : [];
    var result = {
      value: value ? Number(valueSplit[0]) : null,
      decimals: 2
    };
    if (valueSplit.length > 1) {
      return _objectSpread(_objectSpread({}, result), {}, {
        value2: value ? Number(valueSplit[1]) : null,
        isRange: true
      });
    }
    return result;
  },
  component: PercentLabel,
  label: 'Interés nominal',
  type: 'number'
}, {
  id: 'originCountry',
  map: function map(product) {
    return meta(product, 'country_display_name');
  },
  mapCompare: function mapCompare(product) {
    return meta(product, 'country_display_name') ? meta(product, 'country_display_name').data : '';
  },
  productType: ['deposit'],
  compare: compare,
  props: function props(_ref126) {
    var value = _ref126.value;
    return {
      value: value
    };
  },
  component: ProductMetadata,
  label: 'País',
  type: 'string',
  tooltip: {
    title: 'País',
    text: 'País en el que tributa el producto.'
  }
}, {
  id: 'termMonthsCount',
  map: function map(_ref127) {
    var entity = _ref127.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'term_months_count';
    });
  },
  mapCompare: function mapCompare(_ref128) {
    var entity = _ref128.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'term_months_count';
    }) ? Number(entity.metadata.find(function (item) {
      return item.meta === 'term_months_count';
    }).data) : 0;
  },
  productType: ['deposit'],
  compare: compare,
  props: function props(_ref129) {
    var value = _ref129.value;
    return {
      value: value ? "".concat(value.data, " meses") : ''
    };
  },
  label: 'Plazo',
  type: 'string',
  tooltip: {
    title: 'Plazo',
    text: 'Período de tiempo que dura la inversión.'
  }
}, {
  id: 'earlyTerminationEnabled',
  map: function map(product) {
    return meta(product, 'early_termination_enabled');
  },
  productType: ['deposit'],
  props: function props(_ref130) {
    var value = _ref130.value;
    if (value) {
      return {
        value: value.data === '1' ? 'Sí' : 'No'
      };
    }
    return {
      value: ''
    };
  },
  label: 'Cancelación anticipada',
  type: 'string'
}, {
  id: 'document',
  map: function map(product) {
    return meta(product, 'document_url');
  },
  productType: ['deposit'],
  compare: compare,
  component: Link,
  props: function props(_ref131) {
    var value = _ref131.value;
    return value ? {
      target: '_blank',
      text: 'Documentación',
      href: value.data
    } : null;
  },
  label: 'Documentación',
  type: 'number'
}, {
  id: 'currency',
  map: function map(product) {
    return meta(product, 'currency_code');
  },
  productType: ['deposit'],
  props: function props(_ref132) {
    var value = _ref132.value;
    return {
      value: value ? value.data : ''
    };
  },
  label: 'Divisa',
  type: 'string'
}, {
  id: 'countryCreditRating',
  map: function map(product) {
    return meta(product, 'country_credit_rating');
  },
  productType: ['deposit'],
  props: function props(_ref133) {
    var value = _ref133.value;
    return {
      value: value ? value.data : ''
    };
  },
  label: 'Calificación crediticia',
  type: 'string'
}, {
  id: 'bank',
  map: function map(product) {
    return meta(product, 'bank_display_name');
  },
  productType: ['deposit'],
  props: function props(_ref134) {
    var value = _ref134.value;
    return {
      value: value ? value.data : ''
    };
  },
  label: 'Banco',
  type: 'string'
}, {
  id: 'maxInvestment',
  map: function map(product) {
    return meta(product, 'maximum_investment_amount');
  },
  mapCompare: function mapCompare(_ref135) {
    var entity = _ref135.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'maximum_investment_amount';
    }) ? Number(entity.metadata.find(function (item) {
      return item.meta === 'maximun_investment_amount';
    }).data) : 0;
  },
  productType: ['deposit'],
  compare: compare,
  component: QuoteLabel,
  props: function props(_ref136) {
    var value = _ref136.value;
    return {
      value: value ? Number(value.data) : null,
      decimals: 0
    };
  },
  label: 'Inversión máxima',
  type: 'number'
}, {
  id: 'price',
  map: function map(_ref137) {
    var entity = _ref137.entity;
    return entity.minInvestment;
  },
  label: 'IVA incluido'
}, {
  id: 'minInvestment',
  map: function map(_ref138) {
    var entity = _ref138.entity;
    return entity;
  },
  props: function props(_ref139) {
    var entity = _ref139.value,
      productType = _ref139.productType,
      params = _ref139.params;
    return {
      params: params,
      entity: entity,
      productType: productType,
      decimals: 0
    };
  },
  component: FundMinInvestment,
  productType: iicTypes,
  label: 'Inversión mínima',
  type: 'number',
  tooltip: tooltips.minInvestment
}, {
  id: 'minInvestment',
  map: function map(_ref140) {
    var entity = _ref140.entity;
    return entity.minInvestment;
  },
  label: 'Inversión mínima',
  tooltip: tooltips.minInvestment
}, {
  id: 'commission',
  map: function map(_ref141) {
    var entity = _ref141.entity;
    return entity.commission;
  },
  label: 'Comisión',
  tooltip: {
    title: 'Comisión',
    text: 'Porcentaje del capital invertido que se ha de pagar por la compra o venta del producto, su gestión, su custodia...'
  }
}, {
  id: 'isin',
  map: function map(_ref142) {
    var entity = _ref142.entity;
    return entity.isin;
  },
  productType: iicTypes,
  label: function label(product, _ref143) {
    var id = _ref143.id;
    return ['plan'].includes(id) ? 'DGS' : 'ISIN';
  }
}, {
  id: 'classes',
  productType: iicTypes,
  map: function map(product) {
    return product;
  },
  component: FundClasses,
  props: function props(_ref144) {
    var product = _ref144.value,
      productType = _ref144.productType,
      params = _ref144.params;
    return {
      product: product,
      productType: productType,
      withModal: params.withModal,
      withISIN: params.withISIN,
      withPaddingTop: params.withPaddingTop
    };
  },
  label: 'Clases disponibles',
  defaultParams: {
    wrap: 'nowrap'
  }
}, {
  id: 'buyButton',
  map: function map(product) {
    return product;
  },
  component: BuyButton,
  props: function props(_ref145) {
    var product = _ref145.product,
      actions = _ref145.actions,
      params = _ref145.params;
    return {
      product: product,
      onAction: actions.onProductRequest ? function () {
        return actions.onProductRequest(product);
      } : null,
      variant: params.variant || 'textButton',
      width: params.width || 'auto',
      withSPA: params.withSPA || false
    };
  },
  label: 'Me interesa'
}, {
  id: 'managementCompany',
  productType: iicTypes,
  map: function map(_ref146) {
    var entity = _ref146.entity;
    return entity.managementCompany;
  },
  component: ManagementCompany,
  props: function props(_ref147) {
    var managementCompany = _ref147.value,
      productType = _ref147.productType,
      params = _ref147.params;
    return {
      managementCompany: managementCompany,
      productType: productType,
      variant: params.variant || 'link'
    };
  },
  mapCompare: function mapCompare(_ref148) {
    var entity = _ref148.entity;
    return entity.managementCompany ? entity.managementCompany.name : '';
  },
  compare: compare,
  label: 'Gestora',
  defaultParams: {
    wrap: 'nowrap'
  }
}, {
  id: 'managementFee',
  productType: iicTypes,
  map: function map(product) {
    return product;
  },
  component: FundClassFee,
  props: function props(_ref149) {
    var product = _ref149.value,
      productType = _ref149.productType;
    return {
      product: product,
      productType: productType
    };
  },
  label: 'Comisión (máxima)',
  complement: {
    id: 'feature',
    feature: 'cost'
  }
}, {
  id: 'riskProfile',
  productType: iicTypes,
  map: function map(product) {
    return product;
  },
  component: RiskProfile,
  props: function props(_ref150) {
    var product = _ref150.value,
      productType = _ref150.productType;
    return {
      product: product,
      productType: productType
    };
  },
  label: 'Nivel de riesgo',
  complement: 'userRiskProfile'
}, {
  id: 'riskProfile-new',
  map: function map(_ref151) {
    var entity = _ref151.entity;
    return {
      value: entity.srri
    };
  },
  props: function props(_ref152) {
    var value = _ref152.value,
      params = _ref152.params;
    return {
      value: value ? value.value : null,
      unit: 'range',
      label: params.label,
      to: 7,
      border: params.border,
      withTextColor: false,
      fullWidth: true,
      withSpacer: true
    };
  },
  label: function label(_ref153) {
    var _label5 = _ref153.label;
    return _label5;
  },
  component: InfoLabel
}, {
  id: 'userRiskProfile',
  productType: iicTypes,
  map: function map(product) {
    return product;
  },
  component: RiskProfileUserHint,
  props: function props(_ref154) {
    var product = _ref154.value,
      productType = _ref154.productType,
      user = _ref154.user,
      actions = _ref154.actions;
    return {
      product: product,
      productType: productType,
      user: user,
      onAction: actions.onUserRiskAction
    };
  },
  label: 'Tu perfil inversor'
}, {
  id: 'category',
  productType: iicTypes,
  map: function map(_ref155, _ref156) {
    var entity = _ref155.entity;
    var partner = _ref156.partner;
    var categoryProvider = partner.iic.categoryProvider;
    var categories = isArray(entity.category) ? entity.category : entity.categories;
    return getCategoryByProvider(categories, categoryProvider);
  },
  component: Category,
  mapCompare: function mapCompare(_ref157, _ref158) {
    var entity = _ref157.entity;
    var partner = _ref158.partner;
    var categories = isArray(entity.category) ? entity.category : entity.categories;
    var _getCategoryByProvide = getCategoryByProvider(categories, partner.iic.categoryProvider),
      _getCategoryByProvide2 = _getCategoryByProvide.name,
      name = _getCategoryByProvide2 === void 0 ? '' : _getCategoryByProvide2;
    return name;
  },
  compare: compare,
  props: function props(_ref159) {
    var category = _ref159.value,
      productType = _ref159.productType;
    return {
      category: category,
      productType: productType,
      variant: 'link'
    };
  },
  label: 'Categoría',
  defaultParams: {
    wrap: 'nowrap'
  }
}, {
  id: 'inceptionDate',
  productType: iicTypes,
  map: function map(_ref160) {
    var entity = _ref160.entity;
    return new Date(entity.available);
  },
  component: DateLabel,
  props: function props(_ref161) {
    var value = _ref161.value;
    return {
      date: value,
      noTimeTag: true
    };
  },
  label: 'Fecha de inicio'
}, {
  id: 'srri',
  productType: iicTypes,
  map: function map(_ref162) {
    var entity = _ref162.entity;
    return entity.srri;
  },
  component: SrriBar,
  props: function props(_ref163) {
    var value = _ref163.value;
    return {
      value: value,
      size: 'tiny'
    };
  },
  mapCompare: function mapCompare(_ref164) {
    var entity = _ref164.entity;
    return entity.srri ? entity.srri : 0;
  },
  compare: compare,
  label: 'SRRI',
  tooltip: tooltips.srri
}, {
  id: 'TextESGRating',
  productType: iicTypes,
  map: function map(_ref165) {
    var entity = _ref165.entity;
    return entity.stats.ESG;
  },
  component: TextESGRating,
  props: function props(_ref166) {
    var value = _ref166.value;
    return {
      value: value
    };
  },
  mapCompare: function mapCompare(_ref167) {
    var entity = _ref167.entity;
    return entity.stats.ESG ? entity.stats.ESG.score : 0;
  },
  compare: compare,
  label: 'Rating de sostenibilidad',
  tooltip: {
    title: 'Rating de sostenibilidad',
    text: 'Rating de sostenibilidad de Morningstar.'
  },
  complement: {
    id: 'ESGRating'
  }
}, {
  id: 'ESGRating',
  productType: iicTypes,
  map: function map(_ref168) {
    var entity = _ref168.entity;
    return entity.stats.ESG;
  },
  component: ESGRating,
  props: function props(_ref169) {
    var value = _ref169.value;
    return {
      value: value
    };
  },
  mapCompare: function mapCompare(_ref170) {
    var entity = _ref170.entity;
    return entity.stats.ESG ? entity.stats.ESG.score : 0;
  },
  compare: compare,
  label: 'Rating ESG',
  tooltip: {
    title: 'Rating de sostenibilidad',
    text: 'Rating de sostenibilidad de Morningstar.'
  }
}, {
  id: 'lastQuote',
  productType: iicTypes,
  map: function map(_ref171) {
    var entity = _ref171.entity;
    return {
      lastQuote: entity.lastQuote,
      currency: entity.currency
    };
  },
  component: QuoteLabel,
  props: function props(_ref172) {
    var _value$currency;
    var value = _ref172.value;
    return value.lastQuote ? {
      value: value.lastQuote.price,
      currency: (_value$currency = value.currency) === null || _value$currency === void 0 ? void 0 : _value$currency.code
    } : null;
  },
  label: 'Valor liquidativo',
  type: 'number'
}, {
  id: 'currency',
  productType: iicTypes,
  map: function map(_ref173) {
    var entity = _ref173.entity;
    return entity.currency || null;
  },
  props: function props(_ref174) {
    var value = _ref174.value;
    return {
      value: value === null || value === void 0 ? void 0 : value.code
    };
  },
  label: 'Divisa',
  type: 'string'
}, {
  id: 'lastQuoteHeadline',
  productType: iicTypes,
  map: function map(product) {
    return product;
  },
  component: LastQuoteHeadline,
  props: function props(_ref175) {
    var value = _ref175.value;
    return {
      product: value
    };
  }
}, {
  id: 'region',
  map: function map(product) {
    return meta(product, 'region');
  },
  mapCompare: function mapCompare(product) {
    return meta(product, 'region') ? meta(product, 'region').data : '';
  },
  compare: compare,
  props: function props(_ref176) {
    var value = _ref176.value;
    return {
      value: value ? value.data : null
    };
  },
  label: 'Región'
}, {
  id: 'index',
  map: function map(product) {
    return meta(product, 'index');
  },
  mapCompare: function mapCompare(product) {
    return meta(product, 'index') ? meta(product, 'index').data : '';
  },
  compare: compare,
  props: function props(_ref177) {
    var value = _ref177.value;
    return {
      value: value ? value.data : null
    };
  },
  label: 'Índice'
}, {
  id: 'metadata',
  component: ProductMetadata,
  map: function map(product, _ref178) {
    var metadata = _ref178.metadata;
    var definition = metadatas.find(function (item) {
      return item.id === metadata;
    });
    return {
      value: meta(product, definition.id),
      definition: definition
    };
  },
  mapCompare: function mapCompare(product, _ref179) {
    var metadata = _ref179.metadata;
    var def = metadatas.find(function (item) {
      return item.id === metadata;
    });
    var value = meta(product, def.id);
    return value ? value.data : '';
  },
  mapValue: function mapValue(product, _ref180) {
    var metadata = _ref180.metadata;
    var def = metadatas.find(function (item) {
      return item.id === metadata;
    });
    var value = meta(product, def.id);
    return value ? value.data : null;
  },
  props: function props(_ref181) {
    var value = _ref181.value;
    return {
      value: value.value,
      definition: value.definition
    };
  },
  compare: compare,
  label: function label(params) {
    var def = metadatas.find(function (item) {
      return item.id === params.metadata;
    });
    return def.label;
  },
  tooltip: function tooltip(params) {
    var def = metadatas.find(function (_ref182) {
      var id = _ref182.id;
      return id === params.metadata;
    });
    return def.tooltip;
  }
}, {
  id: 'srriFeatured',
  map: function map(_ref183) {
    var entity = _ref183.entity;
    var value = entity.srri;
    return value ? {
      alias: 'srri',
      name: 'nivel de riesgo',
      score: value < 2 ? 1 : value < 4 ? 3 : value >= 3 ? 4 : null
    } : {
      alias: null,
      name: null,
      score: null
    };
  },
  mapCompare: function mapCompare(_ref184) {
    var entity = _ref184.entity;
    return entity.srri ? entity.srri : 0;
  },
  props: function props(_ref185) {
    var value = _ref185.value;
    return {
      value: value
    };
  },
  compare: compare,
  component: Feature,
  label: function label(params) {
    return params.label;
  },
  tooltip: tooltips.srri
}, {
  id: 'contentPerformance',
  map: function map(_ref186) {
    var entity = _ref186.entity;
    return entity.performance;
  },
  mapCompare: function mapCompare(_ref187) {
    var entity = _ref187.entity;
    return entity.performance ? entity.performance.value : 0;
  },
  props: function props(_ref188) {
    var value = _ref188.value;
    return {
      value: value ? value.value : null,
      decimals: 2,
      withSparkline: true
    };
  },
  compare: compare,
  component: PercentLabel,
  label: 'Rentabilidad 36M'
}, {
  id: 'cost',
  map: function map(_ref189) {
    var entity = _ref189.entity;
    return entity.metadata.find(function (item) {
      return item.meta === 'price';
    });
  },
  props: function props(_ref190) {
    var value = _ref190.value;
    return {
      value: value ? Number(value.data) : null,
      decimals: value ? Number(value.data) % 1 === 0 ? 0 : 2 : 0
    };
  },
  component: Price,
  label: 'Precio'
}, {
  id: 'date',
  map: function map(_ref191) {
    var entity = _ref191.entity;
    return entity.commission;
  },
  productType: ['course'],
  label: 'Fecha',
  tooltip: {
    title: 'Fecha',
    text: 'El curso se celebrará en estas fechas'
  }
}, {
  id: 'questions',
  map: function map(_ref192) {
    var entity = _ref192.entity;
    return entity.socialStats.questions;
  },
  props: function props(_ref193) {
    var product = _ref193.product,
      value = _ref193.value,
      params = _ref193.params;
    return {
      product: product,
      value: value,
      variant: params.variant
    };
  },
  component: Questions,
  label: function label(_ref194) {
    var variant = _ref194.variant;
    return ['count'].includes(variant) ? 'P' : 'Dudas resueltas';
  }
}, {
  id: 'reviews',
  map: function map(_ref195) {
    var entity = _ref195.entity;
    return entity.socialStats.reviews;
  },
  props: function props(_ref196) {
    var product = _ref196.product,
      value = _ref196.value,
      params = _ref196.params;
    return {
      product: product,
      value: value,
      variant: params.variant
    };
  },
  component: Reviews,
  label: function label(_ref197) {
    var variant = _ref197.variant;
    return ['count'].includes(variant) ? 'R' : 'Opiniones';
  }
}, {
  id: 'likeDate',
  map: function map(_ref198) {
    var created = _ref198.created;
    return created;
  },
  props: function props(_ref199) {
    var value = _ref199.value;
    return {
      date: new Date(value),
      format: 'LL'
    };
  },
  component: DateLabel,
  label: 'Fecha seguimiento'
}, {
  id: 'likeAction',
  map: function map(product) {
    return product;
  },
  component: LikeAction,
  props: function props(_ref200) {
    var product = _ref200.product,
      actions = _ref200.actions,
      productsSubscriptions = _ref200.productsSubscriptions;
    return {
      onClick: function onClick() {
        actions.onProductSubscription('product', 'subscribe', product.entity.id, !productsSubscriptions.includes(product.entity.id), product);
      },
      active: productsSubscriptions.includes(product.entity.id)
    };
  },
  label: ''
}];
export var productEntity = {
  id: 'product',
  fields: productFields
};